import { render, staticRenderFns } from "./courseApplyDetailForm.vue?vue&type=template&id=5e021232&scoped=true"
import script from "./courseApplyDetailForm.vue?vue&type=script&setup=true&lang=js"
export * from "./courseApplyDetailForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./courseApplyDetailForm.vue?vue&type=style&index=0&id=5e021232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e021232",
  null
  
)

export default component.exports